import { Space } from "antd";
import styled from "styled-components";

export const Container = styled(Space)`
	width: 100%;
	max-width: 480px;
	padding: 12px 0 10px;
	align-items: flex-end;
	text-align: center;
	.ant-space-item {
		flex: 0.25;
	}
	background: ${(props) => props.theme.appbarColor};
	position: fixed;
	bottom: 0;
	margin-bottom: 0;
	z-index: 600;
	
	@media screen and (max-width: 353px){
		svg {
			width: 16px;
			height: 16px;
		}
	}
	@media screen and (max-width: 378px ) and (min-width: 358px){
		padding: 10px 0px 10px;
	}
`;

export const ItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ItemWrapper = styled.div`
	margin-top: 8px;
	text-align: center;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	gap: 0;
	@media screen and (max-width: 360px){
		margin-top:	0px;
		margin-bottom: 4px;
	}
`;

export const Label = styled.div`
	font-size: 10px;
	font-style: normal;
	letter-spacing: normal;
	line-height: 1.5;
	font-weight: 400;
	color: ${(props) => (props.status === "active" ? "#FFFFFF" : "#8FDCFF")};

	@media screen and (max-width: 367px) {
		font-size: 8px !important;
	}
`;


